import { v4 as uuidv4 } from 'uuid';
import { APP_LOADED } from '../../../../settings/settings';

export default function browserSession(
  state = {
    sessionId: null,
  },
  { type }
) {
  switch (type) {
    case `${APP_LOADED}_FULFILLED`:
      return {
        ...state,
        sessionId: uuidv4(),
      };
    default:
      return state;
  }
}
